<script lang="ts">
  import Pin from "../assets/images/pin.svg";
  import type { AutocompletePrediction } from "../lib/google/maps/types";

  export let prediction: AutocompletePrediction;
  export let predictionSelected: (prediction: AutocompletePrediction) => void;
</script>

<button class="py-3 px-4 flex pointer max-w-full" on:click|preventDefault={() => predictionSelected(prediction)}>
  <img src={Pin} class="px-2 self-center" alt="Pin" />
  <p class="address-text text-ellipsis whitespace-nowrap overflow-hidden">
    <span class="prediction-main-text grow">{prediction.structured_formatting.main_text}</span>
    <span class="prediction-secondary-text grow-0">{prediction.structured_formatting.secondary_text}</span>
  </p>
</button>

<style>
  .prediction-secondary-text, .address-text {
    color: var(--color-grayscale-50);
  }

  .prediction-main-text {
    color: black;
  }
</style>
